export class DeliveryOpsApi {
    client;
    constructor(client) {
        this.client = client;
    }
    /** Open a claim against a delivery, snapshotting the declared value (operator). */
    open(input) {
        return this.client.request({ method: 'POST', path: '/v1/delivery-ops/claims', body: input, auth: true });
    }
    /** Move a claim into investigation (from opened, or after an appeal re-opens it). */
    investigate(claimId) {
        return this.client.request({ method: 'POST', path: `/v1/delivery-ops/claims/${encodeURIComponent(claimId)}/investigate`, body: {}, auth: true });
    }
    /** Record the bounded compensation decision on an investigating claim. */
    decide(claimId, input) {
        return this.client.request({ method: 'POST', path: `/v1/delivery-ops/claims/${encodeURIComponent(claimId)}/decide`, body: input, auth: true });
    }
    /** File the single permitted appeal against a decided (rejected/partial) claim. */
    appeal(claimId) {
        return this.client.request({ method: 'POST', path: `/v1/delivery-ops/claims/${encodeURIComponent(claimId)}/appeal`, body: {}, auth: true });
    }
    /** Close a claim — terminal (withdrawal from opened, or settlement from decided/appealed). */
    close(claimId) {
        return this.client.request({ method: 'POST', path: `/v1/delivery-ops/claims/${encodeURIComponent(claimId)}/close`, body: {}, auth: true });
    }
    /** Append a piece of evidence (a reference, never bytes) to the append-only evidence log. */
    addEvidence(claimId, input) {
        return this.client.request({ method: 'POST', path: `/v1/delivery-ops/claims/${encodeURIComponent(claimId)}/evidence`, body: input, auth: true });
    }
    /** Read a claim snapshot + version + its evidence log + its audit trail (operator). */
    get(claimId) {
        return this.client.request({ method: 'GET', path: `/v1/delivery-ops/claims/${encodeURIComponent(claimId)}`, auth: true });
    }
    /** The ops worklist: open claims, newest first (operator). */
    listOpen() {
        return this.client.request({ method: 'GET', path: '/v1/delivery-ops/claims', auth: true });
    }
}
//# sourceMappingURL=delivery-ops.js.map